import { create } from "zustand";
import { usePurchaseOrders } from "../../usePurchaseOrders";
import { frontDB } from "../../../../frontDB";
import { selectAllOptions } from "../../../Settings/Data/lists";
import { showToast } from "../../../../Components/Toast";
import api from "../../../../api";
import moment from "moment";

export let usePurchaseOrdersHeader = create((set, get) => ({
  filter: {
    locationId: "*",
    date: new Date(),
    status: "*",
    statuses: selectAllOptions.map((item) => {
      return item.value;
    }),
    // Empty = all types. Filled = only those requisition types.
    types: [],
    from: moment().utc().subtract(3, "month").startOf("day").toDate(),
    to: moment().utc().add(1, "day").endOf("day").toDate(),
  },

  selectedStatuses: selectAllOptions,
  selectedTypes: [],

  setSelectedLocation: () => {
    let { location } = frontDB.getState();
    const currentLocationId = get().filter.locationId;
    const newLocationId = location ? location._id : "*";

    if (newLocationId !== currentLocationId) {
      set({ filter: { ...get().filter, locationId: newLocationId } });

      // Reset page and fetch data from usePurchaseOrders store
      const { setActivePage, getPurchaseOrders } = usePurchaseOrders.getState();
      setActivePage(1);
      getPurchaseOrders();
    }
  },

  statusHandler: (value) => {
    set({ filter: { ...get().filter, status: value } });
  },

  handleStatusChange: (value) => {
    if (!value) value = selectAllOptions;
    set({ selectedStatuses: value });
    let statuses = get().selectedStatuses.map((item) => {
      return item.value;
    });

    //console.log(value);
    set({ filter: { ...get().filter, statuses } });
    usePurchaseOrders.setState({ activePage: 1 });
    usePurchaseOrders.getState().getPurchaseOrders();
  },

  handleTypeChange: (value) => {
    const selectedTypes = value || [];
    const types = selectedTypes.map((item) => item.value);
    set({ selectedTypes, filter: { ...get().filter, types } });
    usePurchaseOrders.setState({ activePage: 1 });
    usePurchaseOrders.getState().getPurchaseOrders();
  },

  locationHandler: (value) => {
    set({ filter: { ...get().filter, locationId: value } });
    usePurchaseOrders.setState({ activePage: 1 });
    usePurchaseOrders.getState().getPurchaseOrders();
  },

  searchValues: {
    title: undefined,
    requisitionNumber: undefined,
    itemsLocation: undefined,
    vendor: undefined,
    portName: undefined,
  },

  latestSearchRequest: null,

  searchClearHandler: (id) => {
    let { getPurchaseOrders, setTableLoading } = usePurchaseOrders.getState();
    setTableLoading(true);
    let { searchValues, latestSearchRequest } = get();
    set({ searchValues: { ...searchValues, [id]: "" } });
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }
    latestSearchRequest = setTimeout(() => {
      usePurchaseOrders.setState({ activePage: 1 });
      getPurchaseOrders();
      setTableLoading(false);
    }, 500);

    set({ latestSearchRequest });
  },

  searchInputHandler: (value, e) => {
    let { getPurchaseOrders, setTableLoading } = usePurchaseOrders.getState();

    setTableLoading(true);

    let { searchValues, latestSearchRequest } = get();
    let id = e.target.id;

    set({ searchValues: { ...searchValues, [id]: value } });

    console.log(searchValues);
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }

    latestSearchRequest = setTimeout(() => {
      usePurchaseOrders.setState({ activePage: 1 });
      getPurchaseOrders();
      setTableLoading(false);
    }, 500);

    set({ latestSearchRequest });
  },

  periodFromHandler: (v, e) => {
    if (!v) return;
    let from = moment(v).utc().startOf("day").format();
    set({ filter: { ...get().filter, from: v } });
    usePurchaseOrders.setState({ activePage: 1 });
    usePurchaseOrders.getState().getPurchaseOrders();
  },

  periodToHandler: (v, e) => {
    if (!v) return;
    let to = moment(v).utc().startOf("day").format();
    set({ filter: { ...get().filter, to: v } });
    usePurchaseOrders.setState({ activePage: 1 });
    usePurchaseOrders.getState().getPurchaseOrders();
  },

  periodRangeHandler: (range) => {
    if (!Array.isArray(range) || range.length !== 2) return;

    const [fromValue, toValue] = range;
    if (!fromValue || !toValue) return;

    set({
      filter: {
        ...get().filter,
        from: moment(fromValue).utc().startOf("day").toDate(),
        to: moment(toValue).utc().endOf("day").toDate(),
      },
    });

    usePurchaseOrders.setState({ activePage: 1 });
    usePurchaseOrders.getState().getPurchaseOrders();
  },

  onExport: async (filter, purchaseOrdersArrayLength) => {
    //set({ generatingRL: true });
    if (!purchaseOrdersArrayLength) {
      showToast("e", "No purchase orders were found in the search results");
      return;
    }
    if (filter.locationId == "*") {
      showToast(
        "e",
        "Please choose a vessel before exporting the purchase order list",
      );
    } else {
      const response =
        await api.purchaseOrder.generatePurchaseOrderExcel(filter);

      const fileBlob = response.data;
      if (fileBlob) {
        let { locations } = frontDB.getState();
        const vessel = locations.find((obj) => obj._id === filter.locationId);

        const now = new Date();
        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = now.getFullYear();
        const hour = String(now.getHours()).padStart(2, "0");
        const minute = String(now.getMinutes()).padStart(2, "0");
        const filename = `${vessel.name}_PurchaseOrders_${day}-${month}-${year}_${hour}-${minute}.xlsx`;
        const blob = new Blob([fileBlob], { type: fileBlob.type });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        showToast("e", "Error generating Purchase Orders export file");
      }
      set({ generatingRL: false });
    }
  },
}));

// const unsubscribe = usePurchaseOrdersHeader.subscribe((newState, prevState) => {
//   if (prevState.filter !== newState.filter) {
//     usePurchaseOrders.setState({ activePage: 1 });
//     usePurchaseOrders.getState().getPurchaseOrders();
//   }
// });
